import { alphanumericRegExp, emailRegExp, localeService } from '../../core';
import { REQUIRED_OPTIONS, MAX_SLUG_LENGTH } from '../../core/constants';
import { getPasswordStrength } from '../../core/helpers';
import { MIN_SLUG_LENGTH } from '../../settings/tabs/room/constants';
const EMAIL_MAX_LENGTH = 100;
const CLINIC_NAME_MIN_LENGTH = 3;
const CLINIC_NAME_MAX_LENGTH = 100;
const validateSignUpForm = (values, hasClinicSignUpPath) => {
    const errors = {};
    const { email, title, firstName, lastName, roomName, password, clinicDomain, clinicName, } = values;
    const passwordDetails = getPasswordStrength(password);
    if (!email) {
        errors.email = localeService.formatMessageById('validation.signUp.missingEmail');
    }
    else {
        const isEmailValid = emailRegExp.test(email.toLowerCase());
        if (!isEmailValid) {
            errors.email = localeService.formatMessageById('validation.invalidEmail');
        }
        else if (email.length > EMAIL_MAX_LENGTH) {
            errors.email = localeService.formatMessageById('validation.invalidEmail.tooLong', { limit: EMAIL_MAX_LENGTH });
        }
    }
    if (!title) {
        errors.title = localeService.formatMessageById('validation.signUp.missingTitle');
    }
    if (!firstName) {
        errors.firstName = localeService.formatMessageById('validation.signUp.missingFirstName');
    }
    if (!lastName) {
        errors.lastName = localeService.formatMessageById('validation.signUp.missingLastName');
    }
    if (!roomName) {
        errors.roomName = localeService.formatMessageById('validation.signUp.missingRoomName');
    }
    else if (roomName.length < MIN_SLUG_LENGTH) {
        errors.roomName = localeService.formatMessageById('form.errors.minLength', {
            number: MIN_SLUG_LENGTH - 1,
        });
    }
    else if (roomName.length > MAX_SLUG_LENGTH) {
        errors.roomName = localeService.formatMessageById('form.errors.maxLength', {
            number: MAX_SLUG_LENGTH,
        });
    }
    else if (!alphanumericRegExp.test(roomName)) {
        errors.roomName = localeService.formatMessageById('form.errors.alphanumeric');
    }
    if (!password) {
        errors.password = localeService.formatMessageById('validation.signUp.missingPassword');
    }
    else if (passwordDetails.length < 8 ||
        !REQUIRED_OPTIONS.every((option) => passwordDetails.contains.includes(option))) {
        errors.password = localeService.formatMessageById('validation.signUp.weakPassword');
    }
    if (hasClinicSignUpPath) {
        if (!clinicName) {
            errors.clinicName = localeService.formatMessageById('validation.signUP.clinicName');
        }
        else if (clinicName.length < CLINIC_NAME_MIN_LENGTH) {
            errors.clinicName = localeService.formatMessageById('validation.signUP.clinicName.length');
        }
        else if (clinicName.length > CLINIC_NAME_MAX_LENGTH) {
            errors.clinicName = localeService.formatMessageById('validation.signUP.clinicName.tooLong', { limit: CLINIC_NAME_MAX_LENGTH });
        }
        if (!clinicDomain) {
            errors.clinicDomain = localeService.formatMessageById('validation.signUP.clinicDomain');
        }
        else {
            if (clinicDomain.length > 15) {
                errors.clinicDomain = localeService.formatMessageById('validation.signup.clinicDomain.lengthShorter');
            }
            if (clinicDomain.length < 3) {
                errors.clinicDomain = localeService.formatMessageById('validation.signup.clinicDomain.lengthLonger');
            }
            if (!/^[\dA-Za-z]*$/.test(clinicDomain)) {
                errors.clinicDomain = localeService.formatMessageById('validation.signup.clinicDomain.onlyLettersandNumbers');
            }
        }
    }
    return errors;
};
export default validateSignUpForm;
